import { Injectable, inject } from '@angular/core';
import axios, { AxiosError } from 'axios';
import { environment } from 'src/environments/environment';
import { PayeeCasesService } from './payee-cases.service';
import { CaseTableItem, Product } from './types';

const COFACE_PRODUCT_TYPE: Product = 'coface';

type CofaceCaseStatusResponse = {
  case: CaseTableItem;
};

@Injectable({
  providedIn: 'root',
})
export class CofaceCasesService {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly loadingCaseIds = new Set<string>();

  constructor() {
    this.payeeCasesService.cases.subscribe(async cases => {
      await Promise.allSettled(cases.data.map(c => this.refreshCofaceStatusIfNeeded(c)));
    });
  }

  isCofaceStatusLoading(caseId: string): boolean {
    return this.loadingCaseIds.has(caseId);
  }

  private async refreshCofaceStatusIfNeeded(item: CaseTableItem): Promise<void> {
    if (
      item.product_type !== COFACE_PRODUCT_TYPE
      || this.loadingCaseIds.has(item.id)
      || !item.coface_expired
    ) {
      return;
    }

    this.loadingCaseIds.add(item.id);

    try {
      const url = `${environment.baseUrl}/api/case/${item.id}/coface-case-status`;
      const res = await axios.get<CofaceCaseStatusResponse>(url);
      if (res.data.case) {
        Object.assign(item, res.data.case);
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.status === 422) {
        return;
      }
      console.error('Failed to refresh Coface case status', error);
    } finally {
      this.loadingCaseIds.delete(item.id);
    }
  }
}
